import { Box, Container, Heading, Text, Link } from '@chakra-ui/react';
import Header from '../partials/common/header/header';
import Footer from '../partials/common/footer/footer';

function ContactPage() {
    return (
        <>
            <Header />
            <Container py={20} px={{ base: 18, md: 28 }} width={"100%"} maxW={"100%"} centerContent>
                <Heading>Contact Us</Heading>
                <Box mt={10} textAlign="center">
                    <Text fontSize="lg">
                        Have a question or need assistance? We'd love to hear from you!
                    </Text>
                    <Text mt={4}>
                        For all other questions, partnerships, or feedback, please email us. Our team will get back to you as soon as possible.
                    </Text>
                    <Text mt={6} fontSize="xl" fontWeight="bold">
                        Email: <Link href="mailto:contact@travelnex.in" color="brand.500">contact@travelnex.in</Link>
                    </Text>
                </Box>
            </Container>
            <Footer />
        </>
    );
}

export default ContactPage;